// @flow
import React from 'react';
import styled from 'styled-components';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import * as Buttons from 'styles/Buttons';
import { media } from 'styles/Mixins';

const AppTabContainer = styled(RenterApp.AppTabContainer)`
  width: 300px;
  margin: 154px auto;
  ${media.md`
    margin: 176px auto;   
  `}
`;
const MessageText = styled.span`
  display: block;
  min-height: 19px;
  width: 100%;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 40px;
  text-align: center;
  ${media.md`
    margin-bottom: 20px;    
  `}
`;

const ResumeAppButton = styled(Buttons.PrimaryButton)`
  margin-bottom: 40px;
`;

const CancelButton = styled(Buttons.TextStyledButton)`
  min-height: 19px;
  font-size: 16px;
  line-height: 19px;
`;

type PropsType = {
  resumeAction: () => void,
  cancelAction: () => void
};

export default class ResumeContentComponent extends React.Component<PropsType> {
  constructor(props: PropsType) {
    super(props);
  }

  render() {
    const { resumeAction } = this.props;
    return (
      <AppTabContainer>
        <MessageText>Todavía no terminas tu aplicación.</MessageText>
        <ResumeAppButton onClick={() => resumeAction()}>Reanudar aplicación</ResumeAppButton>
        <CancelButton>Quiero aplicar a otro departamento</CancelButton>
      </AppTabContainer>
    );
  }
}
